(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["custom-group-slider"] && !Shopify.designMode) return;
  try {
    document.addEventListener('DOMContentLoaded', function() {
      const sliders = document.querySelectorAll('.hero-content-slider > .group-block__media-wrapper + .group-block-content');

      sliders.forEach(slider => {
        const $slider = $(slider);

        // Create counter element
        const counter = document.createElement('div');
        counter.className = 'slick-counter';
        counter.textContent = '1 / ' + $slider.children().length;
        slider.parentElement.appendChild(counter);

        // Initialize Slick
        $slider.on('init reInit afterChange', function(event, slick, currentSlide, nextSlide){
          const i = (currentSlide ? currentSlide : 0) + 1;
          counter.textContent = i + ' / ' + slick.slideCount;
        });

        // Init only if not already done
        if (!$slider.hasClass('slick-initialized')) {
          $slider.slick({
            slidesToShow: 1,
            slidesToScroll: 1,
            autoplay: true,
            arrows: false,
            dots: false,
            infinite: false,
            adaptiveHeight: true
          });
        }
      });
    });
  } catch(e) { console.error(e); }
})();

})();
